import ToastCtrl from "./toast/toast.controller";
import ToastTmpl from "./toast/toast.html";
import constants from "../../core/constants";

class Controller {
  constructor(Socket, $mdToast) {
    "ngInject";

    this.Socket = Socket;
    this.$mdToast = $mdToast;
  }
  $onInit() {
    const socket = this.Socket.dashboard();
    const showToast = (ticket) => {
      this.$mdToast.show({
        hideDelay: constants.ticketNotificationDelay,
        position: "top left",
        toastClass: "ticket-notification-toast",
        controller: ToastCtrl,
        controllerAs: "$ctrl",
        template: ToastTmpl,
        locals: { ticket },
      });
    };
    const onTicket = (data) => {
      const ticket = data.ticket;
      showToast(ticket);
    };

    socket.on("ticket:create", onTicket);
    socket.on("ticket:update", onTicket);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/ticketNotification/ticketNotification.controller.js